import React, { useState } from 'react';
import band1 from './images/band_1.svg';
import band2 from './images/band_2.svg';
import band3 from './images/band_3.svg';
import icon5 from './images/icon_5.png';

import Overlay from './components/Overlay';
import { Grid, Row, Column, CTA, GlobalFooter } from '@symposium/ui-react';
import { Header, HeaderLogo } from '@symposium/ui-react/es/components/Header/index';
import { Headline, Subheadline, BodyText } from '@symposium/ui-react/es/components/Typography';

function App() {
  const [openOverlay, setOpenOverlay] = useState(false);
  function handleClick() {
    setOpenOverlay(!openOverlay);
  }
  return (
    <main>
      <Header>
        <HeaderLogo
          src='https://marketplace.redhat.com/en-us/assets/red-hat-marketplace-logo-horizontal-reverse.svg'
          alt='Red Hat Marketplace logo'
          title='Red Hat Marketplace logo'
          href='/en-us'
        />
      </Header>

      {/* 1 Band */}
      <Grid className='bg-white'>
        <Row>
          <Column span={{ lg: 7, md: 4, sm: 4 }}>
            <div className='padding-t-100 padding-b-32'>
              <Headline component='h1' gutterBottom={5}>
                Introducing Red Hat® Marketplace
              </Headline>
              <Subheadline component='h2'>
                A simpler way to try, buy, and manage enterprise software.
              </Subheadline>
            </div>
            <div className='padding-b-32'>
              <CTA id='button' onClick={() => setOpenOverlay(true)}>
                Watch the video
              </CTA>
            </div>
          </Column>
          <Column className='padding-t-32 padding-b-32 video-mobile' span={{ lg: 7, md: 4, sm: 4 }}>
            <div className='band-1__video-placeholder' tabIndex='0'>
              <div onClick={() => setOpenOverlay(true)} className='react-player__shadow band-1'>
                <div className='react-player__play-icon band-1__play-icon'></div>
              </div>
            </div>
          </Column>
          {openOverlay && <Overlay handler={handleClick} />}
        </Row>
      </Grid>
      {/* 1 Band */}

      {/* 2 Band */}
      <Grid fullWidth className='bg-gray padding-t-48 padding-b-48'>
        <Row>
          <Column offset={[1]} span={{ lg: 5, md: 4, sm: 4 }}>
            <div>
              <Headline component='h2' type={5} gutterBottom={5}>
                Try certified software for Red Hat OpenShift
              </Headline>
              <BodyText gutterBottom={5}>
                Developers can have new software up and running smoothly when they need it. All
                software on Red Hat Marketplace uses Kubernetes operators for built-in management
                logic. This provides consistent upgrades and patches, backup and recovery, log
                processing, scaling, and more.
              </BodyText>
            </div>
            <div className='padding-t-16'>
              <CTA href='https://marketplace.redhat.com/en-us/search'>Browse software</CTA>
            </div>
          </Column>
          <Column span={{ lg: 5, md: 4, sm: 4 }}>
            <img
              src={band2}
              alt='Illustration showing a check list of itens to get Certified Enterprise Ready'
            />
          </Column>
        </Row>
      </Grid>
      {/* 2 Band */}

      {/* 3 Band */}
      <Grid fullWidth className='bg-white padding-t-48 padding-b-48'>
        <Row>
          <Column offset={[1]} span={{ lg: 5, md: 4, sm: 4 }}>
            <img
              src={band1}
              alt='Illustration using desktops and clouds on the background with charts over them.'
            />
          </Column>
          <Column span={{ lg: 5, md: 4, sm: 4 }}>
            <div>
              <Headline component='h2' type={5} gutterBottom={5}>
                Buy and deploy <br /> software to any cloud
              </Headline>
              <BodyText gutterBottom={5}>
                Red Hat® Marketplace makes it easier to discover and try certified software for
                container-based environments in public clouds and on-prem. With automated
                deployment, software is immediately available to deploy on any Red Hat OpenShift®
                cluster, providing a fast, integrated experience.
              </BodyText>
            </div>
            <div className='padding-t-16'>
              <CTA href='https://marketplace.redhat.com/en-us/registration/rhm'>Get Started</CTA>
            </div>
          </Column>
        </Row>
      </Grid>
      {/* 3 Band */}

      {/* 4 Band */}
      <Grid fullWidth className='bg-gray padding-t-100 padding-b-48' id='select'>
        <Row>
          <Column offset={[1]} span={{ lg: 5, md: 4, sm: 4 }}>
            <img
              src={band3}
              alt='Illustration of a woman sitting in a workstation and looking at charts on her computer.'
            />
          </Column>
          <Column span={{ lg: 5, md: 4, sm: 4 }}>
            <div>
              <Headline component='h2' type={5} gutterBottom={5}>
                <h2>Find and deploy software faster</h2>
              </Headline>
              <BodyText gutterBottom={5}>
                Red Hat Marketplace Select lets your teams quickly discover preapproved solutions,
                build, and deploy faster on Red Hat OpenShift while providing clear visibility into
                usage and spending patterns. From chargebacks to project-level spending, Red Hat
                Marketplace Select gives you control to maximize your investments and ensure
                compliance and governance.
              </BodyText>
            </div>
            <div className='padding-t-16'>
              <CTA href='https://marketplace.redhat.com/en-us/enterprise-solutions'>Learn more</CTA>
            </div>
          </Column>
        </Row>
      </Grid>
      {/* 4 Band */}

      {/* 7 Band */}
      <Grid fullWidth className='bg-white'>
        <Row>
          <Column offset={[1]} span={{ lg: 6, md: 8, sm: 4 }}>
            <div className='padding-t-48 padding-b-24'>
              <Headline component='h2' type={5} gutterBottom={5}>
                Hear what partners love about Red Hat Marketplace
              </Headline>
            </div>
            <div className='padding-b-32'>
              <BodyText gutterBottom={5}>
                The contributions of independent software vendors (ISVs) add many products for your
                application <br /> development. Here’s why some are taking part.
              </BodyText>
            </div>
          </Column>
        </Row>
      </Grid>
      {/* 7 Band */}

      {/* 8 Band */}
      <Grid fullWidth className='bg-white'>
        <Row>
          <Column offset={[1]} span={{ lg: 6, md: 4, sm: 4 }}>
            <div className='padding-b-48'>
              <img className='icon-32-32' src={icon5} alt='Quotation mark' />
              <BodyText gutterBottom={5}>
                <blockquote>
                  All the solutions on it are OpenShift certified, [and] customers can run solutions
                  on any server. They will integrate seamlessly and securely.”
                </blockquote>
              </BodyText>
              <BodyText type={2} gutterBottom={5}>
                Martin Isaksson, <br /> CEO and co-founder, PerceptiLabs
              </BodyText>
            </div>
          </Column>
          <Column span={{ lg: 6, md: 4, sm: 4 }}>
            <div className='padding-b-48'>
              <img className='icon-32-32' src={icon5} alt='Quotation mark' />
              <BodyText gutterBottom={5}>
                <blockquote>
                  It provides a unique capability for customers to not only buy and try software but
                  also manage their software assets as they buy them.” <br />
                </blockquote>
              </BodyText>
              <BodyText type={2}>
                Raveesh Dewan, <br /> CEO, Joget
              </BodyText>
            </div>
          </Column>
        </Row>
      </Grid>
      {/* 8 Band */}

      {/* 9 Band */}
      <Grid fullWidth className='bg-gray last-band-bg padding-b-48 padding-t-48'>
        <Row>
          <Column offset={[1]} span={{ lg: 8, md: 4, sm: 4 }}>
            <div className='padding-t-48 padding-b-48'>
              <Headline component='h2' type={5} gutterBottom={5}>
                Try and buy software from <br /> Red Hat Marketplace
              </Headline>
            </div>
          </Column>
          <Column span={{ lg: 4, md: 4, sm: 4 }}>
            <div className='padding-b-48 padding-t-48 flex-container'>
              <CTA href='https://marketplace.redhat.com/en-us/registration/rhm'>Get Started</CTA>
            </div>
          </Column>
        </Row>
      </Grid>

      {/* 9 Band */}

      <div className='footer'>
        <GlobalFooter />
      </div>
    </main>
  );
}

export default App;
